export const pages = {
	'hubspotForm': { id: 'hubspotForm', page: 'hubspotForm', getter: () => import(/* webpackChunkName: 'hubspotForm' */ 'components/bolt/hubspotForm/hubspotForm') },
	'boltSynopsis': { id: 'boltSynopsis', page: 'home', getter: () => import(/* webpackChunkName: 'boltSynopsis' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'boltGalleryTrailer', getter: () => import(/* webpackChunkName: "boltGalleryTrailer" */ 'components/bolt/gallery/gallery'), component: 'gallery' },
	{ id: 'boltGallery', getter: () => import(/* webpackChunkName: "boltGallery" */ 'components/bolt/gallery/gallery'), component: 'gallery' },
	{ id: 'hubspotForm', getter: () => import(/* webpackChunkName: "hubspotForm" */ 'components/bolt/hubspotForm/hubspotForm'), component: 'hubspotForm' },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "boltWatchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
